/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Bank_Toast_Generate_ErrorInputs */

const en_story_bank_toast_generate_error = /** @type {(inputs: Story_Bank_Toast_Generate_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to generate stories`)
};

const de_story_bank_toast_generate_error = /** @type {(inputs: Story_Bank_Toast_Generate_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to generate stories`)
};

const fr_story_bank_toast_generate_error = /** @type {(inputs: Story_Bank_Toast_Generate_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to generate stories`)
};

const es_story_bank_toast_generate_error = /** @type {(inputs: Story_Bank_Toast_Generate_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to generate stories`)
};

const it_story_bank_toast_generate_error = /** @type {(inputs: Story_Bank_Toast_Generate_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to generate stories`)
};

const nl_story_bank_toast_generate_error = /** @type {(inputs: Story_Bank_Toast_Generate_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to generate stories`)
};

const pl_story_bank_toast_generate_error = /** @type {(inputs: Story_Bank_Toast_Generate_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to generate stories`)
};

const fi_story_bank_toast_generate_error = /** @type {(inputs: Story_Bank_Toast_Generate_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to generate stories`)
};

const da_story_bank_toast_generate_error = /** @type {(inputs: Story_Bank_Toast_Generate_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to generate stories`)
};

const sv_story_bank_toast_generate_error = /** @type {(inputs: Story_Bank_Toast_Generate_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to generate stories`)
};

/**
* | output |
* | --- |
* | "Failed to generate stories" |
*
* @param {Story_Bank_Toast_Generate_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const story_bank_toast_generate_error = /** @type {((inputs?: Story_Bank_Toast_Generate_ErrorInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Bank_Toast_Generate_ErrorInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_story_bank_toast_generate_error(inputs)
	if (locale === "fr") return fr_story_bank_toast_generate_error(inputs)
	if (locale === "es") return es_story_bank_toast_generate_error(inputs)
	if (locale === "it") return it_story_bank_toast_generate_error(inputs)
	if (locale === "nl") return nl_story_bank_toast_generate_error(inputs)
	if (locale === "pl") return pl_story_bank_toast_generate_error(inputs)
	if (locale === "fi") return fi_story_bank_toast_generate_error(inputs)
	if (locale === "da") return da_story_bank_toast_generate_error(inputs)
	if (locale === "sv") return sv_story_bank_toast_generate_error(inputs)
	return en_story_bank_toast_generate_error(inputs)
});